import React, { useCallback, useEffect, useState } from "react";
import SearchFilter from "../../../components/CustomeFilter/SearchFilter";
import { useLocation, useNavigate } from "react-router";
import OrderStatusButton from "../order/components/OrderStatusButton";
import { CircularProgress, Pagination } from "@mui/material";
import { createSearchParams } from "react-router-dom";
import { getAllVenderList, updateUseAiTitle } from "../../../services/vendor/vendor.service";
import EditTabelDrawer from "../../../components/Edit-tabel-drawer/EditTabelDrawer";
import SweetAlert from "react-bootstrap-sweetalert";
import ManagePricingStrategy from "./components/ManagePricingStrategy";
import ManageLeadTime from "./components/ManageLeadTime";
import ManageVendorStatus from "./components/ManageVendorStatus";
import ManageGlobalMargin from "./components/ManageGlobalMargin";
import ManageCashback from "./components/ManageCashback";
import ProductsStatistics from "./components/ProductsStatistics";
import ProductActions from "./components/ProductActions";
import ManageMarginOverride from "./components/ManageMarginOverride";
import ManageReturnPolicy from "./components/ManageReturnPolicy";
import TableLoader from "../../../components/TableSkelton/TableLoader";
import { BiSolidCircle } from "react-icons/bi";
import DashboardPagesLayout from "../customerServiceDashboard/components/DashboardPagesLayout";
import ShippingConfig from "./components/ShippingConfig";
import ManageMapIps from "./components/ManageMapIps";
import { isDev } from "../../../config/default";

const VendorsNew = () => {
  // hooks
  const navigate = useNavigate();
  const location = useLocation();

  // local state
  const [loading, setLoading] = useState(false);
  const [InnderLoader, setInnderLoader] = useState(false);

  const [Data, setData] = useState([]);
  const [isRender, setIsRender] = useState(false);
  const [pagination, setpagination] = useState({
    currentPage: 1,
    totalPages: 1,
  });
  const [selectedItem, setSelectedItem] = useState({});
  const [Edit, setEdit] = useState({
    open: false,
    edit: "",
    title: "",
  });
  const [pricingAlert, setPricingAlert] = useState({
    open: false,
    vendorName: "",
  });

  const [SearchFillter, setSearchFillter] = useState({
    SearchQuery: "",
    sort: "",
  });

  const fetchData = useCallback(
    async (
      currentPage,
      SearchQuery,
      SearchByCustomer,
      ticketStatus,
      isEscalated,
      attention,
      priority,
      ticketType
    ) => {
      setLoading(true);
      const res = await getAllVenderList(
        currentPage,
        SearchQuery,
        SearchByCustomer,
        ticketStatus,
        isEscalated,
        attention,
        priority,
        ticketType
      );

      if (res) {
        if (!selectedItem) {
          setSelectedItem({});
        } else {
          const newSelected = res?.data?.find(
            (item) => item._id === selectedItem._id
          );
          setSelectedItem(newSelected);
        }

        setData(res?.data);
        setpagination({
          ...res?.pagination,
        });
        setLoading(false);
        setInnderLoader(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [Data, selectedItem]
  );

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const page = parseInt(urlParams.get("page")) || 1;
    if (page !== pagination.currentPage) {
      setpagination(prev => ({ ...prev, currentPage: page }));
    }
  }, [location.search]);

  useEffect(() => {

    let isSubscribe = true;
    if (isSubscribe) {
      fetchData(pagination.currentPage, SearchFillter.SearchQuery);
    }
    return () => {
      isSubscribe = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage, SearchFillter.SearchQuery, isRender]);

  // handle page change query
  const handleChange = (e, value) => {
    const options = {
      pathname: location.pathname,
      search: `?${createSearchParams({ page: value })}`,
    };
    navigate(options, { replace: true });
    setpagination({ ...pagination, currentPage: value });
  };

  const resetToFirstPage = () => {
    setpagination((prev) => ({ ...prev, currentPage: 1 }));
    navigate(
      {
        pathname: location.pathname,
        search: `?${createSearchParams({ page: 1 })}`,
      },
      { replace: true }
    );
  };
  // handle pricetype
  const handlePricingStrategy = (item) => {
    setPricingAlert({
      open: true,
      vendorName: item?.fullName || "",
    });
  };

  // handle pricetype
  const handleLeadTime = (item) => {
    setEdit({
      open: true,
      edit: "leadTime",
      title: ` ${item.fullName} | Estimated Delivery Times`,
    });
    setSelectedItem({ ...item });
  };

  const handleVendorStatus = (item) => {
    setEdit({
      open: true,
      edit: "vendorStatus",
      title: ` ${item.fullName} | Vendor Status`,
    });
    setSelectedItem({ ...item });
  };

  const handleGlobalMargin = (item) => {
    setEdit({
      open: true,
      edit: "globalMargin",
      title: ` ${item.fullName} Margins`,
    });
    setSelectedItem({ ...item });
  };
  const handleCashback = (item) => {
    setEdit({
      open: true,
      edit: "cashback",
      title: ` ${item.fullName} | Cashback Settings`,
    });
    setSelectedItem({ ...item });
  };
  const handleStats = (item) => {
    setEdit({
      open: true,
      edit: "stats",
      title: ` ${item.fullName} | Product Statistics`,
    });
    setSelectedItem({ ...item });
  };

  const handleActions = (item) => {
    setEdit({
      open: true,
      edit: "actions",
      title: ` ${item.fullName} | Actions`,
    });
    setSelectedItem({ ...item });
  };

  const handleMarginOverride = (item) => {
    setEdit({
      open: true,
      edit: "marginOverride",
      title: ` ${item.fullName} | Margins`,
    });
    setSelectedItem({ ...item });
  };
  const handleShippingAlgo = (item) => {
    setEdit({
      open: true,
      edit: "shippingAlgo",
      title: ` Shipping algo:${item.fullName} `,
    });
    setSelectedItem({ ...item });
  };
  const handleReturnPolicy = (item) => {
    setEdit({
      open: true,
      edit: "returnPolicy",
      title: ` ${item.fullName} | Return Policy`,
    });
    setSelectedItem({ ...item });
  };

  const handleMapIps = () => {
    setEdit({
      open: true,
      edit: "mapIps",
      title: "Global Map IP Management",
    });
    setSelectedItem({}); // Not vendor-specific
  };
   const handleUseAiTitleToggle = async (item) => {
    const newUseAiTitle = !item?.useAiTitle;
    
    // Optimistic update
    setData((prevData) => 
      prevData.map((d) => 
        d._id === item._id ? { ...d, useAiTitle: newUseAiTitle } : d
      )
    );

    try {
      await updateUseAiTitle(item._id, newUseAiTitle);
    } catch (error) {
      console.log(error);
      // Revert on error
      setData((prevData) => 
        prevData.map((d) => 
          d._id === item._id ? { ...d, useAiTitle: !newUseAiTitle } : d
        )
      );
    }
  };

  return (
    <>
      <div className=" d-flex  justify-content-end align-center flex-wrap gap-10">
        <SearchFilter
          type="text"
          placeholder={"Search Vendor"}
          value={SearchFillter?.SearchQuery}
          onChange={(e) => {
            resetToFirstPage();
            setSearchFillter({
              ...SearchFillter,
              SearchQuery: e.target.value,
            });
          }}
        />
        <button
          className="btn btn-dark px-4 border-radius-10 font-weight-bold "
          style={{ height: "54px" }}
          onClick={handleMapIps}
        >
          Map IPs
        </button>
      </div>
      <div className=" my-5">
        <DashboardPagesLayout
          pageTitle="All Vendors"
          subTitle="items"
          count={pagination?.count}
          rightHeaderContent={
            <button
              className="btn btn-dark px-4 border-radius-10 font-weight-bold"
              style={{ height: "42px" }}
              onClick={() => navigate("/admin/vendor-coupons")}
            >
              Vendor Promo Scheduler
            </button>
          }
        >
          <div className="process-orders-table">
            <table className="m-0">
              <thead>
                <tr>
                  <th>Status</th>
                  <th>Vendor</th>
                  <th>
                    Pricing <br /> Strategy
                  </th>
                  {/* <th>
                    Global <br /> Margin
                  </th> */}
                  <th>
                    Margins
                  </th>
                  {/* <th>
                    Margin <br /> Override
                  </th> */}
                  <th>Shipping algo</th>
                  <th>Feeds</th>
                  <th>AI Titles</th>
                  <th>
                    Cashback <br /> Percentage
                  </th>
                  <th>
                    Returns
                    <br /> Policy
                  </th>
                  <th>
                    Estimated
                    <br /> Delivery Times
                  </th>
                  <th>Dynamic Pricing</th>
                  <th>Stats</th>
                  <th>Edit</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading && <TableLoader rowsNum={8} cellNum={12} />}

                {!loading &&
                  Data?.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <div
                          className=" c-pointer"
                          onClick={() => handleVendorStatus(item)}
                        >
                          <BiSolidCircle
                            className={
                              !item?.disabled ? "text-success" : "text-muted"
                            }
                          />
                          <span className=" ml-1">
                            {item?.disabled ? "Off" : "Live"}
                          </span>
                        </div>
                      </td>
                      <td className="font-weight-bold">
                        {!item?.disabled ? (
                          <a
                            href={
                              isDev
                                ? `https://qasundial.sundialhome.com/brand/${item?.slug}/1`
                                : `https://www.sundialhome.com/brand/${item?.slug}/1`
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {item?.fullName}
                          </a>
                        ) : (
                          item?.fullName
                        )}
                      </td>

                      <td>
                        <OrderStatusButton
                          onClick={() => handlePricingStrategy(item)}
                          width={190}
                          status={item?.pricingType}
                        >
                          {item?.pricingType === "smart"
                            ? "Smart Map"
                            : item?.pricingType === "break"
                              ? "Break Map"
                              : item?.pricingType === "eliteCashback"
                                ? "Elite Cashback"
                                : item?.pricingType === "standardCoupon"
                                  ? `Standard Coupon (${item?.showCoupon ? "Show" : "Hide"})`
                                  : item?.pricingType === "coupon"
                                    ? "Flash Coupon "
                                    : item?.pricingType === "quote"
                                      ? `Quote (${item?.showCoupon ? "Show" : "Hide"}) `
                                      : item?.pricingType === "concealedCoupon"
                                        ? `Concealed Coupon (${item?.showCoupon ? "Show" : "Hide"}) `
                                        : " "}
                        </OrderStatusButton>
                      </td>
                      <td>
                        {/* {console.log("object", item)} */}
                        <div
                          className=" c-pointer text-white px-3 py-2" style={{ width: "220px", borderRadius: "50px", backgroundColor: item?.isCustomPricing ? "#440e62" : "#004a80" }}
                          // onClick={() => handleGlobalMargin(item)}
                          onClick={() => handleMarginOverride(item)}
                        >
                          {/* {console.log("item",item)} */}
                          Map: <span> {item?.mapPercentage}</span> | Non-MAP: <span>{item?.nonMapPercentage}</span> <br />
                          {item?.isCustomPricing ? (
                            <span><strong style={{ fontSize: "14px" }}>Using Category Margins</strong></span>
                          ) : (
                            <span><strong>Using Default Margins</strong></span>
                          )}

                        </div>
                      </td>
                      <td>
                        {/* {console.log("object", item)} */}
                        <div
                          className=" c-pointer text-white px-3 py-2" style={{ width: "280px", borderRadius: "50px", backgroundColor: "#000" }}
                          // onClick={() => handleGlobalMargin(item)}
                          onClick={() => handleShippingAlgo(item)}
                        >

                          Cube Rate/Min Rate: <strong style={{ fontSize: "14px" }}>{item?.cubeRate}/{item?.minimumRate}</strong> <br />

                          <span>O.P.Fee: <strong style={{ fontSize: "14px" }}>${item?.outSourceFee}</strong></span>
                        </div>
                      </td>
                      {/* <td>
                        <div
                          className=" c-pointer font-weight-bold"
                          onClick={() => handleMarginOverride(item)}
                        >
                          <span>Override</span> <br /> <span>10/30</span>
                        </div>
                      </td> */}
                      <td>
                        <div
                          className=" c-pointer"
                          onClick={() => handleVendorStatus(item)}
                        >
                          <BiSolidCircle
                            className={
                              item?.googleShopping
                                ? "text-success"
                                : "text-muted"
                            }
                          />

                          <span className=" ml-1">
                            {item?.googleShopping ? "live" : "off"}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div
                          className=" c-pointer"
                          onClick={() => handleUseAiTitleToggle(item)}
                        >
                          <BiSolidCircle
                            className={
                              item?.useAiTitle
                                ? "text-success"
                                : "text-muted"
                            }
                          />

                          <span className=" ml-1">
                            {item?.useAiTitle ? "live" : "off"}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div
                          className=" c-pointer font-weight-bold"
                          onClick={() => handleCashback(item)}
                        >
                          Cashback: {item?.cashbackPercentage}%
                        </div>
                      </td>
                      <td>
                        <div
                          className=" c-pointer font-weight-bold"
                          onClick={() => handleReturnPolicy(item)}
                        >
                          <BiSolidCircle
                            className={
                              item?.shippingAndReturns?.policyType === "vendor"
                                ? "text-success"
                                : "text-muted"
                            }
                          />
                          <br />
                          DD: {
                            item?.shippingAndReturns?.defectiveClaimsCutoff
                          }{" "}
                          days / {item?.shippingAndReturns?.defectiveRestockFee}
                          %
                          <br />
                          BR: {item?.shippingAndReturns?.brClaimsCutoff} days /{" "}
                          {item?.shippingAndReturns?.brRestockFee}%
                        </div>
                      </td>
                      <td>
                        <div
                          className=" c-pointer font-weight-bold"
                          onClick={() => handleLeadTime(item)}
                        >
                          <BiSolidCircle
                            className={
                              item?.shippingAndReturns?.policyType === "vendor"
                                ? "text-success"
                                : "text-muted"
                            }
                          />
                          <br />
                          SP:{" "}
                          {item?.shippingAndReturns?.leadTimeSmall +
                            item?.shippingAndReturns?.minShipTimeSmall}
                          -
                          {item?.shippingAndReturns?.leadTimeSmall +
                            item?.shippingAndReturns?.maxShipTimeSmall}{" "}
                          days
                          <br />
                          LTL:{" "}
                          {item?.shippingAndReturns?.leadTimeLTL +
                            item?.shippingAndReturns?.minShipTimeLTL}
                          -
                          {item?.shippingAndReturns?.leadTimeLTL +
                            item?.shippingAndReturns?.maxShipTimeLTL}{" "}
                          days
                        </div>
                      </td>
                      <td>
                        <div
                          className=" c-pointer"
                          onClick={() => handleVendorStatus(item)}
                        >
                          <BiSolidCircle
                            className={
                              item?.dynamicPricing
                                ? "text-success"
                                : "text-muted"
                            }
                          />

                          <span className=" ml-1">
                            {item?.dynamicPricing ? "live" : "off"}
                          </span>
                        </div>
                      </td>
                      <td>
                        <OrderStatusButton
                          onClick={() => handleStats(item)}
                          width={210}
                          status={"+add"}
                        >
                          <span className="ml-2">
                            Stats ({item?.enabledProducts || 0}/{item?.products || 0} • {item?.products > 0 ? Math.round(((item?.enabledProducts || 0) / item.products) * 100) : 0}%)
                          </span>
                        </OrderStatusButton>
                      </td>
                      <td>
                        <OrderStatusButton
                          onClick={() =>
                            navigate(
                              `/admin/vendor/edit-vendor/${item._id
                              }/${item?.fullName.split(" ").join("-")}`
                            )
                          }
                          width={150}
                          status={"+add"}
                        >
                          <span className="ml-2">Edit Vendor</span>
                        </OrderStatusButton>
                      </td>
                      <td>
                        <div
                          className=" c-pointer underlined"
                          onClick={() => handleActions(item)}
                        >
                          Actions
                        </div>
                      </td>
                    </tr>
                  ))}
                {!Data?.length && !loading && (
                  <tr>
                    <td colSpan={20} className=" text-center">
                      "No record Found"
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="d-flex justify-content-center align-center p-2">
              <div className=" mx-auto">
                <Pagination
                  count={pagination.totalPages}
                  page={pagination.currentPage}
                  onChange={handleChange}
                />
              </div>

              <span className=" font-weight-bold" style={{ color: "#9f9f9f" }}>
                {Data?.length} of {pagination?.count} Items
              </span>
            </div>
            <EditTabelDrawer Edit={Edit} setEdit={setEdit}>
              {InnderLoader ? (
                <div className=" d-flex align-center justify-content-center">
                  <CircularProgress />
                </div>
              ) : (
                <>
                  {Edit.edit === "pricingStrategy" && (
                    <ManagePricingStrategy
                      isRender={isRender}
                      setIsRender={setIsRender}
                      selectedItem={{ ...selectedItem, showConsealedCoupon: selectedItem.showCoupon, showStandardCoupon: selectedItem.showCoupon }}
                      setSelectedItem={setSelectedItem}
                    />
                  )}
                  {Edit.edit === "leadTime" && (
                    <ManageLeadTime
                      isRender={isRender}
                      setIsRender={setIsRender}
                      selectedItem={selectedItem}
                      setSelectedItem={setSelectedItem}
                    />
                  )}
                  {Edit.edit === "vendorStatus" && (
                    <ManageVendorStatus
                      isRender={isRender}
                      setIsRender={setIsRender}
                      selectedItem={selectedItem}
                      setSelectedItem={setSelectedItem}
                    />
                  )}
                  {Edit.edit === "globalMargin" && (
                    <ManageGlobalMargin
                      isRender={isRender}
                      setIsRender={setIsRender}
                      selectedItem={selectedItem}
                    />
                  )}
                  {Edit.edit === "cashback" && (
                    <ManageCashback
                      isRender={isRender}
                      setIsRender={setIsRender}
                      selectedItem={selectedItem}
                    />
                  )}
                  {Edit.edit === "stats" && (
                    <ProductsStatistics selectedItem={selectedItem} />
                  )}
                  {Edit.edit === "actions" && (
                    <ProductActions
                      isRender={isRender}
                      setIsRender={setIsRender}
                      selectedItem={selectedItem}
                    />
                  )}
                  {Edit.edit === "marginOverride" && (
                    <ManageMarginOverride
                      isRender={isRender}
                      setIsRender={setIsRender}
                      selectedItem={selectedItem} />
                  )}
                  {Edit.edit === "shippingAlgo" && (
                    <ShippingConfig
                      isRender={isRender}
                      setIsRender={setIsRender}
                      selectedItem={selectedItem}
                    />
                  )}
                  {Edit.edit === "returnPolicy" && (
                    <ManageReturnPolicy
                      isRender={isRender}
                      setIsRender={setIsRender}
                      selectedItem={selectedItem}
                      setSelectedItem={setSelectedItem}
                    />
                  )}
                  {Edit.edit === "mapIps" && (
                    <ManageMapIps />
                  )}
                </>
              )}
            </EditTabelDrawer>
          </div>
        </DashboardPagesLayout>
      </div>

      {/* Pricing Strategy Redirection Alert */}
      {pricingAlert.open && (
        <SweetAlert
          info
          showCancel
          confirmBtnText="Go to Vendor Coupons"
          confirmBtnBsStyle="primary"
          cancelBtnText="Cancel"
          cancelBtnBsStyle="light"
          title="Pricing Strategy & Coupon Portal"
          onConfirm={() => {
            setPricingAlert({ open: false, vendorName: "" });
            navigate("/admin/vendor-coupons");
          }}
          onCancel={() => setPricingAlert({ open: false, vendorName: "" })}
          focusConfirmBtn
        >
          Pricing strategy and coupon updates are disabled here for {pricingAlert.vendorName || "vendors"}. Please manage weekly pricing schedules and coupon configurations in the Vendor Promo Scheduler (Vendor Coupons) portal.
        </SweetAlert>
      )}
    </>
  );
};

export default VendorsNew;
